import { apiClient } from "../config";
async function assignRoles(data: any) {
  const res = await apiClient.put("/admin/assign-roles", data);
  return res.data;
}

export default assignRoles;
